import type { BranchDto } from '@repo/shared-types';

/**
 * Which rows BranchesTab shows for the current toggle state.
 *
 * `branches` is always the FULL fetch (`useBranches({ includeArchived: true })`)
 * so the "show archived" toggle's own visibility can key off it — not off the
 * filtered list. Gating the toggle on the active-only list was the THI-137
 * review bug: an org that archives every branch would fetch zero active rows,
 * the toggle would vanish (an empty list has none), and the archived branches
 * — data intact, UI unreachable — could never be viewed or unarchived again.
 *
 * Pure and colocated in its own module (no i18n/react-query/UI imports) so it
 * stays trivially unit-testable without pulling in this workspace's
 * i18n-bootstrap-reads-localStorage-at-import-time issue (see
 * SettingsSection.test.ts).
 */
export function visibleBranches(branches: BranchDto[], showArchived: boolean): BranchDto[] {
  return showArchived ? branches : branches.filter((b) => b.archivedAt === null);
}
